import shallowEqual from 'fbjs/lib/shallowEqual';

export default shallowEqual;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/shallowEqual.js
// module id = 1654
// module chunks = 0